import { Grid } from "@mui/material";
import { FormikProps } from "formik";
import { COUNTRIES_LIST, STATE_LIST } from "../../../../../../constants";
import CustomSelect from "../../../../../CustomSelect";
import Input from "../../../../../Input";

const AddressCommon = ({
  formik,
  formikKey,
  disabled,
  stateList,
}: {
  formik: FormikProps<any>;
  formikKey: string;
  disabled?: boolean;
  stateList?: { value: string; label: string }[];
}) => {
  const { values, handleBlur, handleChange, setFieldValue } = formik;

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Input
          label="Address Line 1"
          textFieldProps={{
            placeholder: "Address Line 1",
            onChange: handleChange,
            onBlur: handleBlur,
            name: `${formikKey}.line1`,
            value: values[`${formikKey}`]?.line1,
            disabled,
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Input
          label="Address Line 2"
          textFieldProps={{
            placeholder: "Address Line 2",
            onChange: handleChange,
            onBlur: handleBlur,
            name: `${formikKey}.line2`,
            value: values[`${formikKey}`]?.line2,
            disabled,
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Input
          label="City"
          textFieldProps={{
            placeholder: "City",
            onChange: handleChange,
            onBlur: handleBlur,
            name: `${formikKey}.city`,
            value: values[`${formikKey}`]?.city,
            disabled,
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <CustomSelect
          readOnly={!!disabled}
          label="State"
          value={values[`${formikKey}`]?.state}
          options={stateList || STATE_LIST}
          onChange={(val) => setFieldValue(`${formikKey}.state`, val)}
          placeholder="Select"
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <CustomSelect
          readOnly={!!disabled}
          name={`${formikKey}.country`}
          value={values[`${formikKey}`]?.country}
          disableSortOptions
          options={COUNTRIES_LIST}
          onChange={(val) => setFieldValue(`${formikKey}.country`, val)}
          label="Country"
          placeholder="Select Country"
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Input
          label="ZIP Code"
          textFieldProps={{
            placeholder: "ZIP Code",
            onChange: handleChange,
            onBlur: handleBlur,
            name: `${formikKey}.zipcode`,
            value: values[`${formikKey}`]?.zipcode,
            disabled,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default AddressCommon;
